import { render, staticRenderFns } from "./interactDetail.vue?vue&type=template&id=d061afc6&scoped=true&"
import script from "./interactDetail.vue?vue&type=script&lang=js&"
export * from "./interactDetail.vue?vue&type=script&lang=js&"
import style0 from "./interactDetail.vue?vue&type=style&index=0&id=d061afc6&prod&lang=less&scoped=true&"
import style1 from "./interactDetail.vue?vue&type=style&index=1&id=d061afc6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d061afc6",
  null
  
)

export default component.exports